export default function EmptyState({ title, message, icon: Icon, action }) {
    return (
        <div className="bg-white rounded-3xl border border-dashed border-mist p-10 sm:p-14 text-center">
            {Icon && (
                <div className="w-16 h-16 rounded-2xl bg-action-soft text-[#3D6385] mx-auto flex items-center justify-center mb-5">
                    <Icon size={30} strokeWidth={2.2} />
                </div>
            )}
            <div className="font-display font-bold text-2xl text-slate-900 uppercase tracking-tight mb-2">
                {title}
            </div>
            {message && (
                <div className="text-sm text-slate-500 max-w-md mx-auto mb-5">
                    {message}
                </div>
            )}
            {action}
        </div>
    );
}
